import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.auth;

export const authSelectors = {
    isLoggedIn: createSelector(selector, (state) => state.isLoggedIn),
    loggedInUser: createSelector(selector, (state) => state.loggedInUser),
    isInitialized: createSelector(selector, (state) => state.isInitialized),
}
